import React from "react"
import AlertDropDown from "./AlertDropDown"
import { Outlet, useLocation } from "react-router-dom"
import { isIntercomBooted } from "../lib/user"

const INTERCOM_UPDATE_INTERVAL_MS = 5 * 60 * 1000

const GlobalWrapper = () => {
  const location = useLocation()
  const lastUpdateRef = React.useRef(0)

  // Notify Intercom of SPA route changes so it can match URL-based messages.
  // Throttled to avoid hitting Intercom's 20-call/30-min update limit.
  // https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app#tell-intercom-when-your-data-or-url-changes
  React.useEffect(() => {
    if (!isIntercomBooted()) return

    const now = Date.now()
    if (now - lastUpdateRef.current < INTERCOM_UPDATE_INTERVAL_MS) return

    lastUpdateRef.current = now
    window.Intercom?.("update", {
      last_request_at: parseInt(now / 1000),
    })
  }, [location.pathname])

  return (
    <>
      <AlertDropDown />
      <Outlet />
    </>
  )
}

export default GlobalWrapper
